import React from 'react'
import ReactDOM from 'react-dom';
import axios from 'axios';
import TableBodyRow from 'components/group/tableBodyRow';

class Group extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeGroupData: [],
      inactiveGroupData: [],
      expanded: false,
    }
    this.fetchGroupData = this.fetchGroupData.bind(this);
    this.handleDeactivateGroup = this.handleDeactivateGroup.bind(this);
    this.showMore = this.showMore.bind(this);
    this.renderGroups = this.renderGroups.bind(this);
  }

  componentWillMount() {
    this.fetchGroupData();
  }

  showMore() {
    if (this.state.expanded) {
      this.setState({ expanded: false })
    } else {
      this.setState({ expanded: true })
    }
  }

  renderGroups(groupData) {
    return groupData.map((group) => {
      let className = "btn btn-red pull-right"
      if (!group.active) {
        className = "btn btn-blue pull-right"
      }
      return <TableBodyRow user={this.props.user} key={group.id} data={group} className={className} handleDeactivateGroup={this.handleDeactivateGroup} />
    })
  }

  handleDeactivateGroup(event) {
    const groupId = event.target.id

    axios({
      method:'PUT',
      url:`/backend/groups/${groupId}.json`,
      responseType:'json'
    })
    .then((response) => {
      this.fetchGroupData();
    }).catch((error) => {
      console.log(error)
    });
  }

  fetchGroupData(name) {
    axios({
      method:'get',
      url:'/backend/groups.json',
      params: {
        by_name: name,
      },
      responseType:'json'
    })
    .then((response) => {
      this.setState({
        activeGroupData: response.data.active_groups,
        inactiveGroupData: response.data.inactive_groups,
      })
    }).catch((error) => {
      console.log(error)
    });
  }

  render() {
    const { activeGroupData, inactiveGroupData } = this.state;

    return (
      <div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-xs-6">
              <h1>Group</h1>
            </div>
            <div className="col-xs-6">
              {
                !this.props.user.role.includes('readonly') ? (
                <a className="btn btn-dark-blue pull-right" href='/backend/groups/new'>New Group</a>
                ) : null
              }
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row">
            <table className="table table-striped">
              <thead>
                <tr>
                  { this.props.user.role === 'superadmin' ? ( <th>Account</th>) : null }
                  <th>Name</th>
                  <th>Dealers</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                { this.renderGroups(activeGroupData) }
                { this.state.expanded ? this.renderGroups(inactiveGroupData) : null }
              </tbody>
            </table>
            <p>
              <a className="btn btn-primary" onClick={this.showMore}>
                {this.state.expanded ? (
                   <span>Hide archived</span>
                 ) : (
                   <span>Show archived</span>
                 )
                }
              </a>
            </p>
          </div>
        </div>
      </div>
    )
  }
};

export default Group;
